module.exports = __webpack_public_path__ + "img/collection-weddingRingsCrown@2x.adf76bb.webp";